


















import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import {landline, mobile} from '@/utils/validate'
import widgetCommon from './widgetCommon'
import {textFormat} from './types'
import { isUndef } from '@/utils/common'
import {chinese, number1, english, email, phoneOther} from '@/utils/validate'
const valid = {
  chinese,
  english,
  number: number1
}
const validatorMax = (value: string, rule: any, ) => {
    if (!value) {
      return true
    }
    if (!isUndef(rule.max) && (value.length > rule.max)) {
      return false
    } else {
      return true
    }
  }
const validatorMin = (value: string, rule: any) => {
    if (!value) {
      return true
    }
    if (!isUndef(rule.min) && (value.length < rule.min)) {
      return false
    } else {
      return true
    }
  }
const validatorPattern = (value: string, rule: any) => {
    if (!value) {
      return true
    }
    if (!rule.pattern1.test(value)) {
      return false
    } else {
      return true
    }
  }
@Component({
  components: {
  }
})
export default class extends Mixins(widgetCommon) {
  private get placeholder () {
    if (this.item.fieldType === 'autoNumber') {
      return ''
    }
    return this.item.hint || '请输入'
  }
  private get rules () {
    let rules: any = []
    if (this.item.fieldType === 'text') {
      if (this.item.maxContentLength) {
        rules.push({ validator: validatorMax, max: this.item.maxContentLength, message: `最大长度不超过${this.item.maxContentLength}字符`, trigger: 'onBlur' })
      }
      if (this.item.minContentLength) {
        rules.push({ validator: validatorMin, min: this.item.minContentLength, message: `最小长度不少于${this.item.minContentLength}字符`, trigger: 'onBlur' })
      }
      if (this.item.format === textFormat.chinese) {
        rules.push({ validator: validatorPattern, pattern1: chinese, message: '仅中文', trigger: 'onBlur'})
      } else if (this.item.format === textFormat.english) {
        rules.push({ validator: validatorPattern, pattern1: english, message: '仅英文', trigger: 'onBlur'})
      } else if (this.item.format === textFormat.number) {
        rules.push({ validator: validatorPattern, pattern1: number1, message: '仅数字', trigger: 'onBlur'})
      }
    }
    if (this.item.fieldType === 'email') {
      rules.push({ validator: validatorPattern, pattern1: email, message: '请输入正确的邮箱地址', trigger: 'onBlur'})
    }
    if (this.item.fieldType === 'phone') {
      let pattern = this.item.phoneType === 1 ? mobile :
        this.item.phoneType === 2 ? landline : phoneOther
      let message = this.item.phoneType === 2 ? '请输入正确号码(区号-电话号码-分机号码)' : '请输入正确号码'
      rules.push({validator: validatorPattern, pattern1: pattern, message, trigger: 'onBlur'})
    }
    return this.commonRule.concat(rules)
  }
  public initField () {
    if (this.isUndef(this.form[this.item.businessId]) && this.item.defaultType === 1) {
      this.form[this.item.businessId] = this.item.defaultValue || ''
    }
  }
  public resultFn (val: any) {
    return val + ''
  }
  public mounted () {
    if (this.type.includes('record')) {
      this.initField()
    }
  }
}
